import { gql } from "@apollo/client";

export const UPDATE_SKYNET_USER = gql`
  mutation updateSkynetUser($input: UpdateSkynetUserInput!) {
    rolesAndPermissions {
      updateSkynetUser(input: $input) {
        success
      }
    }
  }
`;
